import { LitElement, css, html, keyed } from 'lit'

export class DzComparePanel extends LitElement {
    static get properties() {
        return {
          // ключ localStorage
          datakey: { type: String }, 
        }
    }

    constructor() {
        super()
        this.gap = 1000;
    }

    connectedCallback() {
        super.connectedCallback()
        window.addEventListener(this.datakey, () => {
            this.requestUpdate()
        })
    }

    render() {
        let items = window.objectStorage.getItem(this.datakey)
        let output = []
        let index = 0
        for (let item of items) {
            output.push(keyed(item.key, html`
                <div class="card ${index >= this.gap ? "after-gap": ""}" data-index="${index}" data-key="${item.key}">
                    <div class="picture-box" part="picture-box">
                        <img src="${item.image}"/>
                    </div>
                    <div class="info-box" part="info-box">
                        <div class="brand">${item.brand}</div>
                        <div class="article">${item.article}</div>
                    </div>
                    <div class="close-button" @click=${this.removeItem}>&#10006</div>
                </div>
            `))
            index = index + 1
        }
        if (output.length == 0) {
            this.classList.add("empty")
        } else {
            this.classList.remove("empty")
        }
        let card_width = parseInt(getComputedStyle(this).getPropertyValue('--card-height'))
        this.gap = 1000
        this.style.height = `${(output.length * card_width) + 10}px`;
        return html`${output}`
    }

    removeItem(evt) {
        let card = evt.target.closest(".card")
        this.gap = card.dataset.index
        let new_items = window.objectStorage.getItem(this.datakey).filter((item) => item.key != card.dataset.key)
        window.objectStorage.setItem(this.datakey, new_items)
        evt.stopPropagation()
    }

    static get styles() {
        return css`
            :host {
                display: inline-flex;
                flex-direction: column-reverse;
                transition: 0.2s;
                height: var(--card-height);
                width: var(--card-width);
                transition: 0.5s;
                overflow: hidden;
                background: #FFFFFF;
                border: solid orangered 1px;
                border-left: none;
                box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.2);
                border-radius: 10px;
            }

            .card {
                display: flex;
                justify-content: left;
                flex-shrink: 0;
                width: var(--card-width);
                height: var(--card-height);
                position: relative;
                transition: 0.2s;
                animation: slide-right 0.5s;
                border-bottom: solid #eee 1px;
            }

            .card.after-gap {
                animation: slide-left 0.5s;
            }

            .picture-box {
                max-height: 100%;
                flex-shrink: 0;
                width: var(--card-height);
                padding: 0px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .picture-box img {
                transform: scale(0.5);
                max-height: 100%;
                max-width: 100%;
            }

            .info-box {
                font-size: 12px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
            }

            .close-button {
                position: absolute;
                right: 10px;
                top: 5px;
                font-size: 10px;
                cursor: pointer;
                color: orangered;
            }

            @keyframes slide-right {
                from {
                    top: var(--card-height);
                }
                to {
                    top: 0px;
                }
            }

            @keyframes slide-left {
                from {
                    top: calc(var(--card-height) * -1);
                }
                to {
                    top: 0px;
                }
            }
    `}
}

window.customElements.define('dz-compare-panel', DzComparePanel)